import {AfterViewInit, Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {appConfig} from '../../../config/config';
import {PageRequest} from '../../../shared/models/page-request.interface';
import {MatSort} from '@angular/material/sort';
import {PageEvent} from '@angular/material/paginator';
import {Master} from '../../../admin/models/master.interface';

@Component({
  selector: 'app-kf-next-report-master-table',
  templateUrl: './kf-next-report-master-table.component.html',
  styleUrls: ['./kf-next-report-master-table.component.scss']
})
export class KfNextReportMasterTableComponent implements AfterViewInit {

  pageSizes = appConfig.pageSizes;
  displayedColumns: string[] = ['code', 'description'];

  @Input()
  list!: Master[];
  @Input()
  page!: number;
  @Input()
  pageSize = 100;
  @Input()
  totalElements!: number;

  @Output()
  loadItems: EventEmitter<PageRequest> = new EventEmitter<PageRequest>();

  @ViewChild(MatSort)
  sort!: MatSort;

  constructor() { }

  ngAfterViewInit(): void {
    this.sort.sortChange.subscribe(() => this.onSortChange(this.sort.active, this.sort.direction));
  }

  onSortChange(active: string, direction: string): void {
    this.loadItems.emit({page: 0, size: this.pageSize, sort: active, direction});
  }

  onPageChange(event: PageEvent): void {
    this.loadItems.emit({page: event.pageIndex, size: event.pageSize});
  }

}
